import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    // private toastrService: ToastrService,
    private router: Router,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (request.url.includes('login')) {
          console.warn('could not log in user with email and password');
          return throwError(err?.error);
        }

        // auto logout and handle error if 401 response returned from API
        if (err.status === 401) {
          this.authService.logout();
          this.router.navigate(['/login'])
          console.warn('received a 401');
          if (err?.details) {
            console.warn(err.details);
          }
          if (err?.code) {
            console.warn(err.code);
          }
          return throwError(err?.error);
        }

        if (err.status === 403) {
          // TODO: handle it directly on requested pages
          // this.authService.logoutFromAllAccounts();
          console.warn('received a 403');
          if (err?.details) {
            console.warn(err.details);
          }
          if (err?.code) {
            console.warn(err.code);
          }
          return throwError(err?.error);
        }

        if (err.status === 500) {
          console.error('internal server error');
          // this.toastrService.error(
          //   'Ups, the server had an internal error, please try again later',
          //   'Error',
          //   { closeButton: true }
          // );
        }

        if (err.status === 502 || err.status === 504) {
          console.error('bad gateway or gateway timeout');
          // this.toastrService.error(
          //   'It seems like you are offline, pls get back online and try again',
          //   'Error',
          //   { closeButton: true }
          // );
        }

        // err.error will give the details payload from the server
        return throwError(err?.error);
      })
    );
  }
}
